'use strict';
var parent = require('../../stable/json/stringify');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/json/stringify.js
// module id = 540
// module chunks = 13